





import Vue from 'vue';
import Component from 'vue-class-component';
import BaseComponent from '@/components/base-component.vue';
/**
 * This component is created as a hack for disable autofill from forms with password fields.
 */
@Component
export default class UiDisablePasswordAutofill extends BaseComponent {}
